module.exports = __webpack_public_path__ + "static/avatar-57355068185d70ae8ac2af477187361d.jpg";